import { colors, createMuiTheme } from "@material-ui/core";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#2b9273',
    },
    secondary: {
      main: '#f50057',
    },
  },
});

export default theme;
